define(function(require, exports, module) {
    'use strict';

    var utils = require('utils');
    var _ = require('underscore');
    var ConfigurationClass = require('class/configuration.class');
    var Class = require('Class');

    module.exports = Class.create(ConfigurationClass, {
        initialize: function() {
            ConfigurationClass.prototype.initialize.apply(this, arguments);
            this.load(Playtech.Variables);
        },

        parse: function(originalConfig) {
            var config = utils.deepClone(originalConfig) || {};

            if (!_.isEmpty(config.sessionSubscriptionTypes) && !_.isArray(config.sessionSubscriptionTypes)) {
                config.sessionSubscriptionTypes = config.sessionSubscriptionTypes.replace(/\s/g, '').split(',');
            }

            _.each(['ssoPasDomain', 'ssoPasJsURLs', 'openApiDomain', 'ssoPasExternalJsUrl'], (endpoint) => {
                if (config[endpoint]) {
                    config[endpoint] = this.parseSuperDomainEndpoint(config[endpoint]);
                }
            });

            config.requestStamp = Playtech.Variables.modifiedDate || Date.now();
            config.dateFormat = Playtech.Variables.dateFormat || 'YYYY-MM-DD';
            config.timeFormat = Playtech.Variables.timeFormat || '24-hour';
            config.numberSeparator = Playtech.Variables.numberSeparator || '0,000.00';
            config.currencySymbolPosition = Playtech.Variables.currencySymbolPosition || 'onTheLeft';

            if (!config.isFormsLoaded && config.forms) {
                delete config.forms;
            }

            return config;
        },

        load: function(config) {
            var parsedConfig = this.parse(config);

            //@TODO for backward compatibility. Remove ASAP
            utils.deepExtend(Playtech.Variables, parsedConfig);

            ConfigurationClass.prototype.load.call(this, parsedConfig);
        },

        parseSuperDomainEndpoint: function(endpoint = '') {
            const superDomainRegex = /\[superdomain]/;

            return superDomainRegex.test(endpoint)
                ? endpoint.replace(superDomainRegex, window.location.hostname.split('.').slice(1).join('.'))
                : endpoint;
        }
    });
});
